import React from 'react';

export const WaveSeparator = ({ color = '#fff', flip = false, className = '' }) => (
  <div className={`w-full overflow-hidden leading-[0] ${className}`} style={{ transform: flip ? 'scaleY(-1)' : 'none' }}>
    <svg viewBox="0 0 1440 80" preserveAspectRatio="none" className="w-full block relative" style={{ height: 60 }}>
      <path d="M0,40 C180,80 360,0 540,40 C720,80 900,0 1080,40 C1260,80 1440,0 1440,40 L1440,80 L0,80 Z"
        fill={color} className="animate-wave-slow" />
      <path d="M0,50 C200,20 400,70 600,40 C800,10 1000,60 1200,35 C1350,15 1440,50 1440,50 L1440,80 L0,80 Z"
        fill={color} opacity="0.5" className="animate-wave-slower" />
    </svg>
  </div>
);
